import { render, staticRenderFns } from "./custom-zi-duan.vue?vue&type=template&id=0155b4a6&scoped=true"
import script from "./custom-zi-duan.vue?vue&type=script&lang=js"
export * from "./custom-zi-duan.vue?vue&type=script&lang=js"
import style0 from "./custom-zi-duan.vue?vue&type=style&index=0&id=0155b4a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0155b4a6",
  null
  
)

export default component.exports